import { type FC } from 'react';

import {
  VersionsActionsField,
  VersionsBudgetField,
  VersionsDateField,
  VersionsNameField,
} from '../pages/VersionPage/VersionsTableView/VersionsTable/VersionsFields/index.js';
import { VersionsTableRow, VersionTableColumn } from '../types/versions.js';
import { Columns } from './myCampaigns.js';

const DECIMAL_LIMIT = {
  INTEGER: 0,
  PERCENT: 3,
};

type CellProps = {
  value: string;
  column: VersionTableColumn;
  row: VersionsTableRow;
  cellColor: string;
};

export enum VERSION_ROW_TYPES {
  CHANNEL = 'channel',
  PLATFORM = 'platform',
  VERSION = 'version',
}

export type VersionsColumnsObjectValue = {
  id?: string;
  Header?: string;
  accessor?: string;
  width?: number;
  decimals?: number;
  isPercentField?: boolean;
  isCurrency?: boolean;
  hideColumnForNonFinancialUser?: boolean;
  Cell: FC<CellProps>;
};

type VersionsColumnObject = {
  [key: string]: VersionsColumnsObjectValue;
};

export const versionsColumnsObject: VersionsColumnObject = {
  [Columns.EXPANDER]: {
    id: Columns.EXPANDER,
    Header: '',
    accessor: 'name',
    Cell: VersionsNameField,
    width: 336,
  },
  [Columns.ACTIONS_MENU]: {
    id: Columns.ACTIONS_MENU,
    Header: '',
    accessor: Columns.ACTIONS_MENU,
    Cell: VersionsActionsField,
    width: 48,
  },
  dateFrom: {
    id: 'dateFrom',
    Header: 'Start Date',
    accessor: 'dateFrom',
    Cell: VersionsDateField,
  },
  dateTo: {
    id: 'dateTo',
    Header: 'End Date',
    accessor: 'dateTo',
    Cell: VersionsDateField,
  },
  ctr: {
    id: 'ctr',
    accessor: 'ctr',
    Cell: VersionsBudgetField,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  vtr: {
    id: 'vtr',
    accessor: 'vtr',
    Cell: VersionsBudgetField,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  cr: {
    id: 'cr',
    accessor: 'cr',
    Cell: VersionsBudgetField,
    decimals: DECIMAL_LIMIT.PERCENT,
    isPercentField: true,
  },
  dspCost: {
    accessor: 'dspCost',
    id: 'dspCost',
    Cell: VersionsBudgetField,
    isCurrency: true,
    hideColumnForNonFinancialUser: true,
  },
  otherTechCost: {
    Cell: VersionsBudgetField,
    isCurrency: true,
    hideColumnForNonFinancialUser: true,
  },
  [Columns.ADSERVER_COST]: {
    accessor: Columns.ADSERVER_COST,
    id: Columns.ADSERVER_COST,
    Cell: VersionsBudgetField,
    isCurrency: true,
    hideColumnForNonFinancialUser: true,
  },
  [Columns.BUDGET]: {
    accessor: Columns.BUDGET,
    id: Columns.BUDGET,
    Cell: VersionsBudgetField,
    isCurrency: true,
    hideColumnForNonFinancialUser: true,
  },
  compoundBudget: {
    accessor: 'compoundBudget',
    id: 'compoundBudget',
    Cell: VersionsBudgetField,
    isCurrency: true,
    hideColumnForNonFinancialUser: true,
  },
  calculatedImpressions: {
    Header: 'Impressions*',
    accessor: 'calculatedImpressions',
    id: 'calculatedImpressions',
    Cell: VersionsBudgetField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedLeads: {
    Header: 'Leads*',
    accessor: 'calculatedLeads',
    id: 'calculatedLeads',
    Cell: VersionsBudgetField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedConversions: {
    Header: 'Conversion*',
    accessor: 'calculatedConversions',
    id: 'calculatedConversions',
    Cell: VersionsBudgetField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedVideoViews: {
    Header: 'Video 100% complete*',
    accessor: 'calculatedVideoViews',
    id: 'calculatedVideoViews',
    Cell: VersionsBudgetField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
  calculatedClicks: {
    Header: 'Clicks*',
    accessor: 'calculatedClicks',
    id: 'calculatedClicks',
    Cell: VersionsBudgetField,
    decimals: DECIMAL_LIMIT.INTEGER,
  },
};
